import { FinancialStatementFullWrite } from 'api';

/**
 *
 * @param {*} financialStatementData
 * @param {*} getVersions
 * @param {*} create
 * @param {*} update
 * @param {*} financialStatementSetter
 */
const updateOrCreateFinancialStatement = async ({
  financialStatementData,
  getVersions,
  create,
  update,
  financialStatementSetter,
}: {
  financialStatementData: FinancialStatementFullWrite;
  getVersions: () => Promise<FinancialStatementFullWrite[]>;
  create: (data: any) => Promise<unknown>;
  update: (id: any, data: any) => Promise<unknown>;
  financialStatementSetter?: (financialStatement: FinancialStatementFullWrite) => void;
}) => {
  let savedFinancialStatement: unknown;

  if (!financialStatementData.id) {
    savedFinancialStatement = await create(financialStatementData);
  } else {
    savedFinancialStatement = await update(financialStatementData.id, financialStatementData);
  }
  // changing names requires versions update
  if (savedFinancialStatement) {
    // This function will not be present when updating the statement name
    if (financialStatementSetter) {
      financialStatementSetter(savedFinancialStatement as FinancialStatementFullWrite);
    }
    getVersions();
  }
};

export default updateOrCreateFinancialStatement;
